module.exports = "<!-- <app-home-page></app-home-page> -->"